<h2 class="font-bold text-2xl mb-4">
  <tui-svg src="tuiIconSettingsLarge"></tui-svg>
  {{ 'system.update.title' | transloco }}
</h2>
<div>{{ 'system.update.instruction' | transloco }}</div>
